import request from '../request';
import { API_URL } from '../../utils/constants';
import { SvilaClientEditDto } from '~/src/types/SvilaClientEditDto';

export default {
  getAll: async () => {
    return request(`${API_URL}/svila-clients/get-all`, 'get');
  },

  getById: async (id: string) => {
    return request(`${API_URL}/svila-clients/${id}`, 'get');
  },

  create: async (values: SvilaClientEditDto) => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/svila-clients/create`, 'post', body);
  },

  update: async (id: string, values: SvilaClientEditDto) => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/svila-clients/update/${id}`, 'put', body);
  },

  delete: async (id: string) => {
    return request(`${API_URL}/svila-clients/delete/${id}`, 'delete');
  }
}